import Vue from "vue";
import { io } from "socket.io-client";
import VueSocketIO from "vue-socket.io";
import Vue2TouchEvents from "vue2-touch-events";
import VueHtml2Canvas from "vue-html2canvas";
import vClickOutside from "v-click-outside";
import VueConfirmDialog from "vue-confirm-dialog/src";
import VTooltip from "v-tooltip";
import Moment from "vue-moment";
import Vuelidate from "vuelidate";
import VueMixpanel from "vue-mixpanel";
import VueDraggableResizable from "vue-draggable-resizable";
import VueAlertify from "vue-alertify";
import VueTour from "vue-tour";
import { i18n } from "./plugins/i18n";
import "@/util/extensions.js";

Vue.use(VueAlertify);
Vue.use(VTooltip, {
  popover: { defaultTrigger: "hover", defaultPlacement: "bottom" },
});
Vue.component("v-popover", VTooltip.VPopover);
Vue.use(VueConfirmDialog);
Vue.use(Moment);
Vue.component("vue-confirm-dialog", VueConfirmDialog.default);
Vue.component("vue-draggable-resizable", VueDraggableResizable);
Vue.use(Vuelidate);
Vue.use(VueTour);

import App from "./App.vue";
import router from "./router";
import store from "./store";

const socket = new VueSocketIO({
  debug: false,
  connection: io(process.env.VUE_APP_SOCKET_URL, {
    path:
      process.env.VUE_APP_MODE === "production" ? "/rdcsrv/socket.io/" : null,
  }),
  options: {
    path:
      process.env.VUE_APP_MODE === "production" ? "/rdcsrv/socket.io/" : null,
  },
});

import "@/assets/css/tailwind.base.css";
require("vue-tour/dist/vue-tour.css");

Vue.use(Vue2TouchEvents);
Vue.use(vClickOutside);

Vue.use(socket);
Vue.use(VueHtml2Canvas);

Vue.use(VueMixpanel, {
  token: process.env.VUE_APP_MIX_KEY,
});

store.dispatch("controlMaintenance");
store.dispatch("initAuth").then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
});
